<template>
  <div class="d-flex flex-row">
    <div class="card mt-3 w-100">
      <div class="card-body">
        <h5 class="card-title">{{ indexProperty + 1 }}: {{ user.email }}</h5>
        <table class="formTable w-100">
          <tr>
            <td>Email:</td>
            <td><input class="w-100" type="text" v-model="user.email" /></td>
          </tr>
          <tr>
            <td>Vorname:</td>
            <td>
              <input class="w-100" type="text" v-model="user.firstName" />
            </td>
          </tr>
          <tr>
            <td>Nachname:</td>
            <td><input class="w-100" type="text" v-model="user.lastName" /></td>
          </tr>
          <tr>
            <td>Aktiv bis:</td>
            <td>
              <input class="w-100" type="text" v-model="user.activeUntil" />
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="d-flex flex-column mx-3 mt-3">
      <button
        @click="moveUser(indexProperty, false)"
        class="btn btn-outline-dark btn-block"
      >
        <i class="fas fa-arrow-up"></i>
      </button>
      <button
        @click="moveUser(indexProperty, true)"
        class="btn btn-outline-dark btn-block"
      >
        <i class="fas fa-arrow-down"></i>
      </button>
      <button
        @click="deleteUser(indexProperty)"
        class="btn btn-outline-dark btn-block"
      >
        <i class="far fa-trash-alt"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "notificationUser",
  data() {
    return {
      user: this.userProperty,
      doEdit: this.doEditProperty
    };
  },
  watch: {
    userProperty() {
      this.user = this.userProperty;
    },
    doEditProperty() {
      this.doEdit = this.doEditProperty;
    }
  },
  methods: {
    moveUser(index, up) {
      console.info("emit:moveuser");
      this.$emit("moveuser", index, up);
    },
    deleteUser(index) {
      console.info("emit:deleteuser");
      this.$emit("deleteuser", index);
    }
  },
  props: ["indexProperty", "userProperty", "doEditProperty"]
};
</script>
